import * as React from "react"
import { createPortal } from "react-dom"

/** Renders fixed job-activity chrome on `document.body` so ancestor transforms cannot break positioning. */
export function JobActivityPortal({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = React.useState(false)

  React.useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  return createPortal(children, document.body)
}
